import styles from "./chat-markdown.module.css";

import { ImagineUIMessage } from "@imagine/ai-service/shared-types";
import { Response } from "../ai-elements/response";
import { cn } from "@/lib/utils";

type TextPart = Extract<ImagineUIMessage["parts"][number], { type: "text" }>;

const classNames = cn(styles.chatMarkdown, "chat-response block text-sm");

export function RenderTextPart({ part }: { part: TextPart }) {
  const text = part.text;
  return <Response className={classNames}>{text}</Response>;
}
